module.exports = __webpack_public_path__ + "static/img/10009 (5).bb9d587.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/10000/10009 (5).webp
// module id = AH8W
// module chunks = 14